module.exports = __webpack_public_path__ + "img/rubi.5ee469ee.png";